import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

export const IconGraduateCap: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGraduateCap"><G ClipPath="url(#clip0_9850_24783)"><Path d="M4.50156 11.25V17L12.0014 20.5L19.5016 17V11.25M23.5016 9.5V15.25M12.0014 3.5L1.10156 9L12.0014 14.5L22.9016 9L12.0014 3.5Z" stroke="currentColor" strokeLinecap="square"/></G><Defs><ClipPath id="clip0_9850_24783"><Rect width="24" height="24" fill="white"/></ClipPath></Defs></CentralIconBase>;
});

export default IconGraduateCap;
